module.exports = __webpack_public_path__ + "img/sam-nassour-leopard.ae5adcf.jpg";